// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimGroupViewSearchModel {
    static getAttributeTypeMap() {
        return ClaimGroupViewSearchModel.attributeTypeMap;
    }
}
ClaimGroupViewSearchModel.discriminator = undefined;
ClaimGroupViewSearchModel.additionalProperties = false;
ClaimGroupViewSearchModel.attributeTypeMap = [
    {
        "name": "claimIds",
        "baseName": "claimIds",
        "type": ""
    },
    {
        "name": "claimGroupIds",
        "baseName": "claimGroupIds",
        "type": ""
    },
    {
        "name": "memberNumbers",
        "baseName": "memberNumbers",
        "type": ""
    },
    {
        "name": "includeAdjustments",
        "baseName": "includeAdjustments",
        "type": "boolean"
    },
];
//# sourceMappingURL=claimGroupViewSearchModel.js.map